import SortableHeader from "./sortable-header";
import React from "react";

export default function TableHeader({ headers, sortDir, activeColumn, updateSort}) {
  return (
    <thead className="bg-gray-50 sticky top-0 z-10">
    <tr>
      {headers.map((header) => {
        return (
          <th key={header.name} scope="col" className="whitespace-nowrap px-6 py-3 text-left text-sm font-medium text-gray-500">
            {header.sort ? <SortableHeader
              sortDir={sortDir}
              activeColumn={activeColumn}
              value={header.name}
              column={header.column}
              update={updateSort}
            /> : header.name}
          </th>
        )
      })}
      <th scope="col" className="whitespace-nowrap px-6 py-3 text-left text-sm font-medium text-gray-500">
      </th>
    </tr>
    </thead>
  );
};
